{
  "INTEGRATION_APPS": {
    "FETCHING": "Integraties ophalen",
    "NO_HOOK_CONFIGURED": "Er zijn geen {integrationId} integraties geconfigureerd in dit account.",
    "HEADER": "Applicaties",
    "STATUS": {
      "ENABLED": "Ingeschakeld",
      "DISABLED": "Uitgeschakeld"
    },
    "CONFIGURE": "Configureren",
    "ADD_BUTTON": "Nieuwe hook toevoegen",
    "DELETE": {
      "TITLE": {
        "INBOX": "Verwijdering bevestigen",
        "ACCOUNT": "Verbinding verbreken"
      },
      "MESSAGE": {
        "INBOX": "Weet u zeker dat u wilt verwijderen?",
        "ACCOUNT": "Weet u zeker dat u de verbinding wilt verbreken?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Ja, verwijderen",
        "ACCOUNT": "Ja, verbinding verbreken"
      },
      "CANCEL_BUTTON_TEXT": "Annuleren",
      "API": {
        "SUCCESS_MESSAGE": "Hook succesvol verwijderd",
        "ERROR_MESSAGE": "Kan geen verbinding maken met Woot Server, probeer het later opnieuw"
      }
    },
    "LIST": {
      "FETCHING": "Ophalen van integratie-hooks",
      "INBOX": "Postvak In",
      "EDIT": {
        "BUTTON_TEXT": "Bewerken"
      },
      "DELETE": {
        "BUTTON_TEXT": "Verwijderen"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Selecteer een inbox",
          "PLACEHOLDER": "Selecteer een inbox"
        },
        "SUBMIT": "Aanmaken",
        "CANCEL": "Annuleren"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integratie hook succesvol toegevoegd",
        "ERROR_MESSAGE": "Kan geen verbinding maken met Woot Server, probeer het later opnieuw"
      }
    },
    "EDIT": {
      "TITLE": "{name} bewerken",
      "FORM": {
        "SUBMIT": "Bijwerken",
        "CANCEL": "Annuleren"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integratiehook succesvol bijgewerkt",
        "ERROR_MESSAGE": "Kan geen verbinding maken met de chatserver, probeer het later opnieuw"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Verbinden"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Verbinding verbreken"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Synchroniseer e-mails en webchats met je daktela-account.",
      "RETINO": "Retino brengt structuur in het beheer van retouren en claims.",
      "MAILSHIP": "Mailship is een systeem voor magazijn- en orderafhandelingsbeheer. Zoek bestelstatus, tracking en verzendgegevens op.",
      "RAYNET": "Verbind je Raynet CRM-account om toegang te krijgen tot je klantgegevens. Voeg een verbinding toe met je Raynet-gebruikersnaam en API-token."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Verbinding testen",
      "SUCCESS": "Verbinding geslaagd",
      "ERROR": "Verbinding mislukt. Controleer je inloggegevens."
    }
  }
}
